import DeudaUpdate from './DeudaUpdate'
export {DeudaUpdate}
export default DeudaUpdate
